(() => {
  const qs = (s, root=document) => root.querySelector(s);
  const qsa = (s, root=document) => [...root.querySelectorAll(s)];
  const currency = (cents) => new Intl.NumberFormat('it-IT',{style:'currency',currency:(window.PrestigeCase?.currency || 'EUR')}).format((cents || 0)/100);
  const escapeHTML = (v='') => String(v).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));

  // Mobile menu
  const menu = qs('[data-mobile-menu]');
  const menuOverlay = qs('[data-menu-overlay]');
  const openMenu = () => { menu?.classList.add('is-open'); menuOverlay?.classList.add('is-open'); document.body.classList.add('menu-open'); menu?.setAttribute('aria-hidden','false'); };
  const closeMenu = () => { menu?.classList.remove('is-open'); menuOverlay?.classList.remove('is-open'); document.body.classList.remove('menu-open'); menu?.setAttribute('aria-hidden','true'); };
  qs('[data-menu-open]')?.addEventListener('click', openMenu);
  qs('[data-menu-close]')?.addEventListener('click', closeMenu);
  menuOverlay?.addEventListener('click', closeMenu);
  qsa('.pc-mobile-menu a').forEach(a => a.addEventListener('click', closeMenu));

  // Gallery
  qsa('[data-gallery-image]').forEach(btn => btn.addEventListener('click', () => {
    const root = btn.closest('.pc-buy-media, .pc-product-gallery, .pc-buy-layout') || document;
    const main = qs('[data-main-product-image]', root) || qs('[data-main-product-image]');
    if (main && btn.dataset.galleryImage) {
      main.style.opacity = '.2';
      const preload = new Image();
      preload.onload = () => { main.src = btn.dataset.galleryImage; main.style.opacity='1'; };
      preload.src = btn.dataset.galleryImage;
    }
  }));

  // Variant swatches, scoped per buybox
  qsa('[data-buybox]').forEach(box => {
    const select = qs('[data-variant-select]', box);
    const price = qs('[data-product-price]', box);
    const name = qs('[data-selected-variant]', box);
    const stock = qs('[data-stock]', box);
    const add = qs('[data-add-cart]', box);
    const colorProperty = qs('[data-color-property]', box);
    const main = qs('[data-main-product-image]', box.closest('.pc-buy-layout')) || qs('[data-main-product-image]');

    if (select) {
      select.addEventListener('change', () => {
        const active = qs(`[data-variant-id="${CSS.escape(select.value)}"]`, box);
        if (active && !active.classList.contains('is-active')) active.click();
      });
    }

    qsa('[data-variant-id]', box).forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.disabled) return;
        qsa('[data-variant-id]', box).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (select) { select.value = btn.dataset.variantId; select.dispatchEvent(new Event('change',{bubbles:true})); }
        if (price) price.textContent = btn.dataset.variantPrice || '';
        if (name) name.textContent = btn.dataset.variantTitle || '';
        if (colorProperty) colorProperty.value = btn.dataset.variantTitle || '';
        qsa('[data-mobile-price]').forEach(el => el.textContent = btn.dataset.variantPrice || '');
        const available = btn.dataset.variantAvailable === 'true';
        if (add) add.disabled = !available;
        if (stock) stock.innerHTML = available ? '<span class="pc-stock__dot"></span> Disponibile' : '<span class="pc-stock__dot pc-stock__dot--off"></span> Momentaneamente esaurito';
        if (main && btn.dataset.variantImage) {
          main.style.opacity='.25';
          const preload = new Image();
          preload.onload=()=>{main.src=btn.dataset.variantImage;main.style.opacity='1';};
          preload.src=btn.dataset.variantImage;
        }
      });
    });
  });

  // Clicking a color card selects that variant and scrolls to buybox
  qsa('[data-scroll-variant]').forEach(card => card.addEventListener('click', e => {
    const id = card.dataset.scrollVariant;
    const swatch = qs(`[data-buybox] [data-variant-id="${CSS.escape(id)}"]`);
    if (swatch && !swatch.disabled) setTimeout(() => swatch.click(), 80);
  }));



  // Fixed color gallery: always visible; try to select the matching Shopify variant by alias.
  const normalizeColor = (v='') => String(v).toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim();
  qsa('[data-color-aliases]').forEach(card => card.addEventListener('click', e => {
    const aliases = (card.dataset.colorAliases || '').split('|').map(normalizeColor).filter(Boolean);
    const candidates = qsa('[data-buybox] [data-variant-id]');
    const match = candidates.find(btn => {
      const title = normalizeColor(btn.dataset.variantTitle || btn.textContent || '');
      return aliases.some(a => title === a);
    });
    if (match && !match.disabled) setTimeout(() => match.click(), 80);
  }));

  // Quantity
  qsa('[data-qty]').forEach(qty => {
    const input = qs('input', qty);
    qs('[data-qty-minus]', qty)?.addEventListener('click', () => input.value = Math.max(1, (parseInt(input.value)||1)-1));
    qs('[data-qty-plus]', qty)?.addEventListener('click', () => input.value = Math.max(1, (parseInt(input.value)||1)+1));
  });

  // Cart drawer
  const drawer = qs('[data-cart-drawer]');
  const cartOverlay = qs('[data-cart-overlay]');
  const openCart = () => { drawer?.classList.add('is-open'); cartOverlay?.classList.add('is-open'); document.body.classList.add('cart-open'); drawer?.setAttribute('aria-hidden','false'); };
  const closeCart = () => { drawer?.classList.remove('is-open'); cartOverlay?.classList.remove('is-open'); document.body.classList.remove('cart-open'); drawer?.setAttribute('aria-hidden','true'); };
  qsa('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  qs('[data-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  qs('[data-cart-close-link]')?.addEventListener('click', closeCart);

  const renderCart = cart => {
    qsa('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const content = qs('[data-cart-content]');
    const footer = qs('[data-cart-footer]');
    if (!content || !footer) return;
    if (!cart.item_count) {
      footer.hidden = true;
      content.innerHTML = `<div class="pc-cart-empty"><span class="pc-cart-empty__mark">PC</span><h3>Il tuo Prestige Case ti aspetta.</h3><p>Scegli il colore più vicino al tuo stile.</p><a href="${window.PrestigeCase?.rootUrl || '/'}#acquista" class="pc-btn pc-btn--dark" data-cart-close-link>Scopri i colori</a></div>`;
      qs('[data-cart-close-link]', content)?.addEventListener('click', closeCart);
      return;
    }
    footer.hidden = false;
    const total = qs('[data-cart-total]', footer);
    if (total) total.textContent = currency(cart.total_price);
    content.innerHTML = cart.items.map(item => `
      <article class="pc-cart-item">
        <a href="${escapeHTML(item.url)}" class="pc-cart-item__image">${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : ''}</a>
        <div>
          <a href="${escapeHTML(item.url)}"><strong>${escapeHTML(item.product_title)}</strong></a>
          ${(item.properties && item.properties.Colore) ? `<span>Colore: ${escapeHTML(item.properties.Colore)}</span>` : (item.variant_title && item.variant_title !== 'Default Title' ? `<span>Colore: ${escapeHTML(item.variant_title)}</span>` : '')}
          <b>${currency(item.final_line_price)}</b>
          <div class="pc-cart-item__controls">
            <button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-change="${escapeHTML(item.key)}" data-quantity="${item.quantity+1}">+</button>
            <button type="button" class="pc-cart-item__remove" data-cart-change="${escapeHTML(item.key)}" data-quantity="0">Rimuovi</button>
          </div>
        </div>
      </article>`).join('');
    bindCartChanges();
  };

  const refreshCart = async(open=false) => {
    const r = await fetch('/cart.js', {headers:{'Accept':'application/json'}});
    const cart = await r.json();
    renderCart(cart);
    if (open) openCart();
  };

  const changeCart = async(key, quantity) => {
    await fetch(window.PrestigeCase?.cartChange || '/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:Number(quantity)})
    });
    await refreshCart();
  };

  const bindCartChanges = () => qsa('[data-cart-change]').forEach(btn => {
    btn.onclick = () => changeCart(btn.dataset.cartChange, btn.dataset.quantity);
  });
  bindCartChanges();

  // AJAX add to cart: explicitly send the selected Shopify variant ID.
  qsa('.pc-product-form').forEach(form => form.addEventListener('submit', async e => {
    if (!e.submitter || !e.submitter.matches('[data-add-cart]')) return;
    e.preventDefault();
    const btn = e.submitter;
    const original = btn.textContent;
    const variantSelect = qs('[data-variant-select]', form);
    const quantityInput = qs('input[name="quantity"]', form);
    const colorInput = qs('[data-color-property]', form);
    const variantId = variantSelect?.value;
    const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10));
    const selectedColor = (colorInput?.value || '').trim();

    if (!variantId) {
      btn.textContent = 'Scegli un colore';
      setTimeout(() => { btn.textContent = original; }, 1400);
      return;
    }

    btn.disabled = true;
    btn.textContent = 'Aggiungo…';
    try {
      const item = { id: Number(variantId), quantity };
      if (selectedColor) item.properties = { Colore: selectedColor };
      const r = await fetch(window.PrestigeCase?.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[item]})
      });
      if (!r.ok) throw new Error('add');
      btn.textContent = 'Aggiunto ✓';
      await refreshCart(true);
    } catch (err) {
      btn.textContent = 'Riprova';
    } finally {
      setTimeout(() => {
        btn.textContent = original;
        const active = qs('[data-variant-id].is-active', form.closest('[data-buybox]'));
        btn.disabled = active ? active.dataset.variantAvailable !== 'true' : false;
      }, 1300);
    }
  }));

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') { closeMenu(); closeCart(); }
  });
})();